import { render, staticRenderFns } from "./pushPreviewV2.vue?vue&type=template&id=08e72dcc&scoped=true"
import script from "./pushPreviewV2.vue?vue&type=script&lang=js"
export * from "./pushPreviewV2.vue?vue&type=script&lang=js"
import style0 from "./pushPreviewV2.vue?vue&type=style&index=0&id=08e72dcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e72dcc",
  null
  
)

export default component.exports